import { render, staticRenderFns } from "./SearchBus.vue?vue&type=template&id=2519e58a&scoped=true"
import script from "./SearchBus.vue?vue&type=script&lang=js"
export * from "./SearchBus.vue?vue&type=script&lang=js"
import style0 from "./SearchBus.vue?vue&type=style&index=0&id=2519e58a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2519e58a",
  null
  
)

export default component.exports